<template>
  <v-card class="mr-3">
    <v-toolbar
      flat
      :dark="!InnungsDunklerText"
      :class="InnungsFarbe"
    >
      <v-toolbar-title>Nächste Termine</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        bottom
        right
        v-if="!innung"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            dark
            icon
            v-on="on"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list class="pt-0">
          <v-list-tile>
            <v-list-tile-title>Termine als ical-Datei laden</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>Kalender in Outlook abonnieren</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>(demnächst)</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <!-- <v-card-text
      class="pa-0 ma-0"
      v-if="!innung "
    >
      <v-list
        two-line
        class="ma-0 py-0"
        v-if="this.events.length > 0"
      >
        <template v-for="(item, abc) in this.events">
          <v-divider
            :key="abc"
            v-if="abc > 0"
          ></v-divider>
          <v-list-tile
            avatar
            :key="abc+'event'"
          >
            <v-list-tile-avatar>
              <v-icon
                :class="item.color ? item.color : 'accent'"
                :dark="!item.dunklertext"
              >event</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title> {{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">
                am {{ new Date(item.date).toLocaleString('de-DE', { day: 'numeric', month: 'short' }) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <span v-else>
        <span v-if="this.BetriebVorhanden">
          <p class="pa-3">
            <v-icon
              left
              small
              color="grey"
            >info</v-icon> Alle Termine ausgeblendet
          </p>
        </span>

        <span v-else>
          <p class="pa-3">
            <v-icon
              left
              color="grey"
            >info</v-icon> Sie sind leider mit keinem Betrieb verknüpft.
          </p>

          <p class="pa-3">
            Als angemeldeter Betrieb bekommen Sie hier die aktuellen Termine Ihrer Innung / Kreishandwerkerschaft angezeigt.
          </p>

        </span>

      </span>
    </v-card-text> -->

    <v-card-text
      class="pa-0 ma-0"
      
    >
      <v-list
        
        class="ma-0 py-0"
        v-if="this.events.length > 0"
      >
        <v-list-group
          v-for="(item, abc) in this.events"
          :key="item.title + abc"
          v-model="item.active"
          no-action
        >
          <template v-slot:activator>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon
                  :class="item.color ? item.color : 'accent'"
                  :dark="!item.dunklertext"
                >event</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  am {{ new Date(item.date).toLocaleString('de-DE', { day: 'numeric', month: 'short' }) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-if="item.details">
            <v-list-tile-content>{{ item.details }}</v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            class=""
            v-if="item.ort"
          >
            <v-list-tile-avatar>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">location_on</v-icon>
                </template>
                <span>Ort der Veranstaltung</span>
              </v-tooltip>

            </v-list-tile-avatar>

            <v-list-tile-content class="pa-0 ma-0" >{{ item.ort }}</v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-if="item.kontakt" class="pa-0 ma-0">
            <v-list-tile-avatar  class="pa-0 ma-0">

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">contact_support</v-icon>
                </template>
                <span>Kontakt</span>
              </v-tooltip>
            </v-list-tile-avatar>

            <v-list-tile-content  class="pa-0 ma-0">{{ item.kontakt }}</v-list-tile-content>
          </v-list-tile>

        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  // props: ['events', 'intern'],
  props: {
    events: Array,
    innung: Object,
    intern: Boolean,
    expand: Boolean
  },
  data: () => ({
    active: null
  }),
  components: {
    // AnfrageVerstecken
  },
  computed: {
    BetriebVorhanden: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.name) return true
      } else {
        return false
      }
    },
    // Farbe der Top-Zeile, 1. kalenderfarbe, 2. Innungsprimärfarbe
    InnungsFarbe: function () {
      var kalfarbe = 'accent'
      if (this.innung) {
        if (this.innung.eigenerkalender) {
          if (this.innung.eigenerkalender.color) {
            kalfarbe = this.innung.eigenerkalender.color
            return kalfarbe
          } else if (this.innung.farbe_prim) {
            kalfarbe = this.innung.farbe_prim
            return kalfarbe
          }
        }
      }
      return kalfarbe
    },
    InnungsDunklerText: function () {
      if (this.innung) {
        if (this.innung.eigenerkalender) {
          if (this.innung.eigenerkalender.dunklertext) {
            return this.innung.eigenerkalender.dunklertext
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style>
</style>